import React from "react";
import { Card, Box } from "@mui/material";
import "./CanvasLayout.css";
import SettingsSlider from "../SettingsSlider";
import CanvasCard from "../CanvasCard";

const CanvasLayout = ({
  options,
  title,
  toggleSettingsPanel,
  isSettingsOpen,
  setOptions,
  isGifSaved,
  setIsGifSaved,
}) => {
  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="flex-start"
        minHeight="calc(100vh - 64px)"
        className="canvasBox"
      >
        <Card
          sx={{
            maxWidth: 1000,
            width: "100%",
            borderRadius: 4,
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            backgroundColor: "white",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center"
          }}
        >
          <div class="container">
            <div class="canvas-container">
              <CanvasCard
                className="canvas-card"
                isGifSaved={isGifSaved}
                options={options}
                title={title}
                setIsGifSaved={setIsGifSaved}
              />
            </div>
            <div class="form-container">
              <SettingsSlider
                toggleSettingsPanel={toggleSettingsPanel}
                isSettingsOpen={isSettingsOpen}
                options={options}
                setOptions={setOptions}
              />
            </div>
          </div>
        </Card>
      </Box>
    </>
  );
};

export default CanvasLayout;
